import { AuthState } from './types';

export function initialState(): AuthState {

  const savedAuthState = localStorage.getItem('app_logged_in');

  return {
    isLoggedIn: savedAuthState === 'true',
    loading: false,
    error: null,
  };
}
